import { AxiosResponse } from "axios";
import { APIClient } from "./axiosClient";
import { QueryParams } from "components/Hooks/useQueryParams";
import { ListResponse } from "./types/general";
import {
  IStatisticArticle,
  IStatisticKeywordTraffic,
} from "./types/_cmsHub";
const api = new APIClient();

const path = "/cmshub";
const cmsHubStatistics = {
  getArticles(
    dataForm: QueryParams
  ): Promise<AxiosResponse<ListResponse<IStatisticArticle>, any>> {
    return api.get(`${path}/statistics/articles`, dataForm);
  },
  getArticlesLogs(dataForm: QueryParams) {
    return api.get(`${path}/statistics/articles/logs`, dataForm);
  },
  getArticlesSummaries(dataForm: QueryParams) {
    return api.get(`${path}/statistics/articles/summaries`, dataForm);
  },
  getVisit(dataForm: QueryParams) {
    return api.get(`${path}/statistics/visit`, dataForm);
  },
  getArticlesKeyword(dataForm: QueryParams) {
    return api.get(`${path}/statistics/keywords`, dataForm);
  },
  getArticlesKeywordInflow(
    dataForm: QueryParams
  ): Promise<AxiosResponse<ListResponse<IStatisticKeywordTraffic>, any>> {
    return api.get(`${path}/statistics/keywords/traffic`, dataForm);
  },
};

export default cmsHubStatistics;
